import React, { FC } from 'react';
import { TIconSize } from '@src/models/common';
import { IClassNameProps } from '@src/models/props';
import { classnames } from '@src/utils/classnames';
import { getClass } from '@src/utils/getClass';
import { Icon } from '../Icon';
import { LOADER_ICON_NAME } from './consts';

import styled from './loading.scss';

interface IProps extends IClassNameProps {
  /** Тема */
  view?: 'white' | 'dark';
  /** Размер */
  size?: TIconSize;
}

/** Иконка лоудера */
export const Loader: FC<IProps> = ({ view = 'dark', className, size = 'md-light' }) => {
  const classes = classnames(className, styled.root, getClass(styled, 'view', view));

  return (
    <div className={classes}>
      <Icon name={LOADER_ICON_NAME[view]} size={size} />
    </div>
  );
};
